export const OPEN_FOLDER = 'open_folder';
export const REFRESH_FOLDER = 'refresh_folder';
export const OPEN_PROJECT = 'open_project';
export const UPDATE_DATA = 'update_data';
export const SELECT_ROW = 'select_row'
export const SHOW_VERIFICATION = 'show_verification';